(function (){
    'use strict';

    angular
        .module('services')
        .factory('Expense', Expense);

    /* @ngInject */
    function Expense ($http, API_BASE) {
        /* Static methods */
        Expense.create = create;
        Expense.find = find;
        Expense.where = where;
        Expense.API_RESOURCE = `${API_BASE}/expenses`;
        // FIXME: this should't be needed; it should be default for the entire app
        Expense.API_OPTIONS = { header: { 'Content-Type': 'application/json; charset=UTF-8' } };

        /* Instance methods */
        Expense.prototype.fill = fill;
        Expense.prototype.save = save;
        Expense.prototype.update = update;
        // Expense.prototype.remove = remove; // TBI
        Expense.prototype.addItem = addItem;
        Expense.prototype.removeItem = removeItem;
        Expense.prototype.updateSubtotal = updateSubtotal;
        Expense.prototype.updateTotal = updateTotal;

        /* Constructor */
        return Expense;

        /* Implementation details */ 
        function Expense(data) {
            this.items = [];
            this.subtotal = 0;
            this.total = 0;
            this.additions = 0;
            this.discounts = 0;
            this.due_date = null;
            this.payment_date = null;
            this.cost_center = null;
            this.payee = null;
            this.bank_account = null;
            this.currency = null;
            this.payment_method = null;
            
            if (data !== undefined) {
                this.fill(data);
            }
        }

        function create(data) {
            let expense = new Expense(data);

            expense.save();

            return expense;
        }
        
        function save() {
            return $http.post(Expense.API_RESOURCE, this, Expense.API_OPTIONS)
                .then(res => new Expense(res.data));
        }

        function find(id) {
            return $http.get(`${Expense.API_RESOURCE}/${id}`, Expense.API_OPTIONS)
                .then(res => new Expense(res.data));
        }

        function fill(data) {
            for (let attr in data) {
                this[attr] = data[attr]; 
            }
            if (data.hasOwnProperty('items') || data.hasOwnProperty('additions') || data.hasOwnProperty('discounts')) {
                this.updateSubtotal();
            }
            return this;
        }

        function update(data) {
            this.fill(data);
            return $http.post(`${Expense.API_RESOURCE}/${this.id}`, this, Expense.API_OPTIONS)
                .then(res => new Expense(res.data));
        }

        // function remove() {
        //     console.log('remove', self.data);
        //     return this;
        // }

        function where(query) {
            return $http.get(Expense.API_RESOURCE, {
                    ...Expense.API_OPTIONS, 
                    params: query
                });
        }

        function addItem(item) {
            this.items.push(item);
            
            this.updateSubtotal();

            return this;
        }

        function removeItem(index) {
            if (!this.items[index].id) {
                this.items.splice(index,1);
            }
            else {
                this.items[index].deleted = true;
            }

            this.updateSubtotal();

            return this;
        }

        function updateSubtotal() {
            this.subtotal = this.items
                .filter(item => !item.deleted)
                .reduce((acc, curr) => 
                    acc + parseFloat(curr.total), 0);

            this.updateTotal();
            
            return this;
        }

        function updateTotal() {
            this.total = (Number(this.subtotal) || 0)
                + (Number(this.additions) || 0)
                - (Number(this.discounts) || 0);
            
            return this;
        }
    }
})();